import styled from "styled-components";

export const LeftImageContainer = styled.div`
  width: 104px;
  height: 104px;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const RightContainer = styled.div`
  width: 128px;
  height: 128px;
  margin-left: -40px;
  position: absolute;
  align-items: center;
  justify-content: center;
`;
